import { render, staticRenderFns } from "./ProfileInfoForms.vue?vue&type=template&id=446fe81f&"
import script from "./ProfileInfoForms.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports